import { Box, MsLink, Text } from "@ms/gatsby-theme";

import type { FC } from "react";

interface FooterAddressInterface {
  supportEmail: string;
}

export const FooterAddress: FC<FooterAddressInterface> = ({ supportEmail }) => (
  <Box>
    <Text variant="sansBody01Regular">
      MANSCAPED®, Inc.
      <br />
      2810 Caribou Court, Suite 140, Carlsbad, CA 92010
      <br />
      (888) 696-6205
      <br />
      <MsLink variant="textLinkLevel3Dark" sx={{ color: "white" }} to={`mailto:${supportEmail}`}>
        {supportEmail}
      </MsLink>
    </Text>
  </Box>
);
